<template>
    <div class="iqp-ServiceError">
        <i class="fas fa-times-circle error-icon"></i>
        <div class="error-message">
            <div class="error-message-item" v-for="(error, i) in errorsList" :key="i">
                <div class="message" v-html="error.message || error.type"></div>
                <div class="stackTrace" v-if="error.stackTrace">
                    <el-collapse v-model="error.collapse">
                        <el-collapse-item name="stackTrace">
                            <template #title>
                                <span class="stackTrace-title">
                                    <el-link type="primary" :underline="false">Подробнее...</el-link>
                                </span>
                            </template>
                            <pre class="stackTrace-message">{{ error.stackTrace }}</pre>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: 'ServiceError',
        props: {
            errors: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            errorsList() {
                return _.map(this.errors, item => ({...item, collapse: ''}));
            }
        }
    }
</script>

<style lang="scss">
    @use "@/assets/variables.scss" as *;

    .iqp-ServiceError {
        position: relative;
        .error-icon {
            color: $iq-color-danger;
            font-size: 21px;
            position: absolute;
            top: 6px;
        }
        .error-message {
            padding: 0 20px 0 35px;
            &-item {
                &:not(:last-child) {
                    margin-bottom: 7px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid $iq-border-color-light;
                }
                .message {
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .stackTrace {
                    &-title {
                        color: $iq-color-danger;
                        font-size: 14px;
                    }
                    &-message {
                        overflow: hidden;
                        overflow-y: auto;
                        color: #606266;
                        font-size: 12px;
                        white-space: pre-wrap;
                        word-wrap: break-word;
                    }
                    .el-collapse {
                        border: none;
                        margin-top: 5px;
                        .el-collapse-item {
                            &__wrap {
                                border: none;
                            }
                            &__header {
                                height: auto;
                                line-height: normal;
                                border: none;
                            }
                            &__arrow {
                                display: none;
                            }
                            &__content {
                                padding-bottom: 0;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
